import { Component, ElementRef, OnInit, QueryList, ViewChild } from '@angular/core';
import { FormControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ColDef, GridReadyEvent } from 'ag-grid-community';
import data from '../../../../assets/add-new-policy-request.json';
import { AppConfig } from '../../../../config/app-config';
import { PROGRAM_MENU, addNewPolicyAccordianData } from '../../../../treo.properties';
import { TreoDatepickerComponent } from '../../../components/treo-datepicker/treo-datepicker.component';

import moment from 'moment';
import { LoaderService } from '../../../../app/core/services/loading.service';
import { ProgramService } from '../programs.service';
@Component({
    selector: 'app-add-new-policy-service-request',
    templateUrl: './add-new-policy-service-request.component.html',
    styleUrls: ['./add-new-policy-service-request.component.scss'],
    standalone: false
})
export class AddNewPolicyServiceRequestComponent implements OnInit {

    @ViewChild('accordion') accordion: QueryList<ElementRef>;

    serviceRequestVOResponse: any;

    serviceRequestLabel = PROGRAM_MENU;

    claimListCreatePanelForm: UntypedFormGroup;

    addNewPolicyStateConfig = AppConfig.addNewPolicyStateConfig;
    addNewPolicySelectRequestConfig = AppConfig.addNewPolicySelectRequestConfig;
    addNewPolicyRequestTextAreaFieldConfig = AppConfig.addNewPolicyRequestTextAreaFieldConfig;
    selectedDate: Date;
    selectedDateList: any[] = []

    showCancelConfirmation: boolean = false;

    insuredNameInputConfig = AppConfig.insuredNameInputConfig;
    companyNameInputConfig = AppConfig.companyNameInputConfig;
    addressLine1InputConfig = AppConfig.addressLine1InputConfig;
    addressLine2InputConfig = AppConfig.addressLine2InputConfig;
    cityNameInputConfig = AppConfig.cityNameInputConfig;
    zipcodeInputConfig = AppConfig.zipcodeInputConfig;
    phoneNumberInputConfig = AppConfig.phoneNumberInputConfig;
    extensionInputConfig = AppConfig.extensionInputConfig;
    recipientMailInputConfig = AppConfig.recipientMailInputConfig;
    addNewPolicyDatePickerConfig = AppConfig.addNewPolicyDatePickerConfig;
    addNewPolicyServiceRequestFormGroup: UntypedFormGroup;
    dateNeededDatePickerConfig = AppConfig.dateNeededDatePickerConfig;
    @ViewChild('reportedEmployerDatePickerStart') reportedEmployerDatePickerStart: TreoDatepickerComponent;
    @ViewChild('requestDetailsTextArea') requestDetailsTextArea: TreoDatepickerComponent;
    @ViewChild('dateNeededPicker') dateNeededPicker: TreoDatepickerComponent;

    requestDataValidationMessage = [
        {
            name: 'required',
            message: "You must select a Request Type to submit the request."
        }
    ]
    requestTextAreaValidation = [
        {
            name: 'required',
            message: "You must either select a policy or enter comments to submit the request."
        }
    ]
    requestDateValidation = [{
        name: 'required',
        message: "You must select an Effective Date of Change"
    }]
    requestDetailsData = [
        {
            requestDetailsTypeFormControl: this.addNewPolicySelectRequestConfig,
            requestDetailsDateControl: this.addNewPolicyDatePickerConfig,
            requestDetailsTextAreaControl: this.addNewPolicyRequestTextAreaFieldConfig,

        }
    ];



    accordionGridData = data.claimsList.config.dataSource1;
    accordionGridHeader = data.claimsList.config.columnHeaders1;
    accordianData = addNewPolicyAccordianData;
    requestDetailsHeader: ColDef[] = [

        {
            headerName: '',
            field: 'selected',
            width: 60,
            cellRenderer: (params: any) => {
                return `<input type="checkbox" ${params.value ? 'checked' : ''} />`;
            },
            cellRendererParams: {
                suppressDoubleClickEdit: true
            },
            onCellClicked: (params: any) => {
            },
            headerCheckboxSelection: true, // ✅ Enables checkbox in header
            headerCheckboxSelectionFilteredOnly: true, // Optional: only selects filtered rows
        },
        {
            headerName: ' NAME INSURED ',
            field: 'nameInsured',
            sortable: false,
            suppressMovable: true,
            lockVisible: true,
            headerClass: 'no-separator ',
            flex: 1
        },
        {
            headerName: 'POLICY NUMBER ',
            field: 'policyNumber',
            sortable: false,
            suppressMovable: true,
            lockVisible: true,
            headerClass: 'no-separator custom-header-margin',
            flex: 1
        },
        {
            headerName: 'POLICY PERIOD ',
            field: 'policyPeriod',
            sortable: false,
            suppressMovable: true,
            lockVisible: true,
            headerClass: 'no-separator custom-header-margin',
            flex: 1
        },
        {
            headerName: 'LINE OF BUSINESS ',
            field: 'lineOfBusiness',
            sortable: false,
            suppressMovable: true,
            lockVisible: true,
            headerClass: 'no-separator custom-header-margin',
            flex: 1
        },
        {
            headerName: 'PRICING PLAN',
            field: 'pricingPlan',
            sortable: false,
            suppressMovable: true,
            lockVisible: true,
            headerClass: 'no-separator custom-header-margin',
            flex: 1
        },
    ]
    additionalRecipients: ColDef[] = [

        {
            headerName: '',
            field: 'selected',
            width: 60,
            cellRenderer: (params: any) => {
                return `<input type="checkbox" ${params.value ? 'checked' : ''} />`;
            },
            cellRendererParams: {
                suppressDoubleClickEdit: true
            },
            onCellClicked: (params: any) => {
            },
            headerCheckboxSelection: true, // ✅ Enables checkbox in header
            headerCheckboxSelectionFilteredOnly: true, // Optional: only selects filtered rows
        },
        {
            headerName: ' USER OF THIS ACCOUNT ',
            field: 'userAccount',
            sortable: false,
            suppressMovable: true,
            lockVisible: true,
            headerClass: 'no-separator ',
            flex: 1
        },
        {
            headerName: ' ROLE ',
            field: 'role',
            sortable: false,
            suppressMovable: true,
            lockVisible: true,
            headerClass: 'no-separator ',
            flex: 1
        },
    ]
    public fieldArray: [{}] = [{ index: 0 }];
    public newAttribute: any = {};
    gridApi: any;
    gridApi1: any;
    showEndFileAttachment: boolean = false;
    dataList: any[] = [];
    public defaultColDef: ColDef = {
        resizable: false,
        autoHeight: true,
        wrapText: true,
        wrapHeaderText: true
    };

    public JSON = JSON;

    constructor(private fb: UntypedFormBuilder, private router: Router, public loaderService: LoaderService, public programsService: ProgramService) { }

    ngOnInit() {
        this.claimListCreatePanelForm = this.fb.group({
            panelName: [''],
            filterCriteria: ['allClaims'],
            columnValue1: ['Claim Number'],
            column2ClaimListSelect: ['claimantNumber'],
            column3ClaimListSelect: ['accidentDate'],
            claimListSortByRadio: ['column3'],
            claimListSortorderRadio: ['descending']
        });

        this.addNewPolicyServiceRequestFormGroup = this.fb.group({
            insuredNameInput: [''],
            companyNameInput: [''],
            addressLine1Input: [''],
            addressLine2Input: [''],
            dateNeededDatePicker: [''],
            cityNameInput: [''],
            zipCodeInput: ['', Validators.required],
            phoneNumberInput: [''],
            extensionInput: [''],
            recipientMailInput: [''],
            addNewPolicyState: [''],
            addNewPolicySelectRequest: [''],
            addNewPolicyDatePicker: [''],
            addNewPolicyRequestTextAreaField: ['']

        })
        this.populateStates();
        this.getPageLoadData();
    }

    populateStates() {
        this.loaderService.showLoader();
        const payload = {
            actionType: "SERVICE_REQUEST",
            operation: "SR_INIT_PARAMS",
            organizationId: atob(sessionStorage.getItem('orgId')),
            applicationAccntDtlId: null,
            sttdId: 18
        };
        this.programsService.fetchData(payload).subscribe({
            next: (resp: any) => {
                this.loaderService.hideLoader();
                const states = resp?.statesVoList.map(item => {
                    return {
                        value: item.sttAbbrvtn,
                        label: item.sttDscrptn
                    };
                }).filter(item => item.value && item.label);

                this.addNewPolicyStateConfig.options = [
                    { value: '', label: 'Please Select' },
                    ...states
                ];
            },
            error: () => {
                this.loaderService.hideLoader();
            }
        });
    }

    getPageLoadData() {
        this.loaderService.showLoader();
        const payload = {
            actionType: "SERVICE_REQUEST",
            operation: "FIND_SR",
            organizationId: atob(sessionStorage.getItem('orgId')),
            applicationAccntDtlId: null
        };
        this.programsService.fetchData(payload).subscribe({
            next: (resp: any) => {
                this.loaderService.hideLoader();
                this.serviceRequestVOResponse = resp.serviceRequestVO;
                console.log('serviceRequestVOResponse', this.serviceRequestVOResponse);
                this.prefillFormWithData();
            },
            error: () => {
                this.loaderService.hideLoader();
            }
        });
    }

    prefillFormWithData() {
        this.prefillContactInfo();
        console.log('addNewPolicyServiceRequestFormGroup', this.addNewPolicyServiceRequestFormGroup.value);
    }

    prefillContactInfo() {

        if (this.serviceRequestVOResponse) {
            // console.log(moment('1753866492104').format("YYYY-MM-DD"));
            // const dt = new Date('1753866492104');
            // console.log(dt);
            // this.serviceRequestVOResponse.dateNeeded = '03/05/2025';
            const insuredName = this.serviceRequestVOResponse?.insuredName || '';
            const company = this.serviceRequestVOResponse?.company || '';
            const addressLn1 = this.serviceRequestVOResponse?.addressLn1 || '';
            const addressLn2 = this.serviceRequestVOResponse?.addressLn2 || '';
            const city = this.serviceRequestVOResponse?.city || '';
            const zipCode = this.serviceRequestVOResponse?.zipCode || '';
            const phoneNumber = this.serviceRequestVOResponse?.phoneNumber || '';
            const ext = this.serviceRequestVOResponse?.ext || '';
            const mailingRecipient = this.serviceRequestVOResponse?.mailingRecipient || '';
            const stateCode = this.serviceRequestVOResponse?.stateCode || '';
            const dateNeeded = this.serviceRequestVOResponse?.dateNeeded || '';

            const formattedDate = dateNeeded ? moment(dateNeeded).format('MM/DD/YYYY') : '';

            this.addNewPolicyServiceRequestFormGroup.patchValue({
                insuredNameInput: insuredName,
                companyNameInput: company,
                addressLine1Input: addressLn1,
                addressLine2Input: addressLn2,
                cityNameInput: city,
                zipCodeInput: zipCode,
                phoneNumberInput: phoneNumber,
                extensionInput: ext,
                recipientMailInput: mailingRecipient,
                addNewPolicyState: stateCode,
                dateNeededDatePicker: formattedDate
            });

            this.dateNeededPicker.date = formattedDate;
        }

    }
    dateChangeHandler(date: any, index: number) {

        if (date) {
            this.selectedDate = date.detail.valueAsDate;
            this.selectedDateList[index] = date
        }
    }
    dateChange(event) { }
    sendPolicyRequest() {
    }
    onCellClicked(event: any) {
    }
    onGridReadyAddendaDocuments(params: GridReadyEvent) {
        this.gridApi = params.api;
        this.gridApi.hideOverlay();
    }
    addFieldValue() {
        let index = this.fieldArray.length;
        this.fieldArray.push({ ...this.newAttribute, index: this.fieldArray.length });
        this.requestDetailsData.push({

            requestDetailsTypeFormControl: {
                ...this.addNewPolicySelectRequestConfig,
                name: 'addNewPolicySelectRequest' + index,
                validations: [],
                value: ''
            },
            requestDetailsDateControl: {
                ...this.addNewPolicyDatePickerConfig,
                name: 'addNewPolicyDatePicker' + index,
                validations: [],
                value: ''

            },
            requestDetailsTextAreaControl: {
                ...this.addNewPolicyRequestTextAreaFieldConfig,
                name: 'addNewPolicyRequestTextAreaField' + index,
                validations: [],
                value: ''
            }
        });
        this.addNewPolicyServiceRequestFormGroup.addControl('addNewPolicySelectRequest' + index, new FormControl(''));
        this.addNewPolicyServiceRequestFormGroup.addControl('addNewPolicyDatePicker' + index, new FormControl(''));
        this.addNewPolicyServiceRequestFormGroup.addControl('addNewPolicyRequestTextAreaField' + index, new FormControl(''));
        this.newAttribute = {};

    }
    removeFieldValue(index) {

        if (index > 0) {
            this.fieldArray.splice(index, 1);

        }
    }
    addFile() {
        this.showEndFileAttachment = true
    }

    cancelForm(): void {
        if (
            this.addNewPolicyServiceRequestFormGroup?.dirty
        ) {
            this.showCancelConfirmation = true;

        }
        else {
            this.router.navigate([`/program/service-requests`]);
        }
    }
    confirmationcancel() {
        this.showCancelConfirmation = false;
    }
    sendRequest() {
        const isRequestDetailsTextValid = this.validateAddNewPolicyRequestTextAreaFieldConfig({
            target: {
                value: this.addNewPolicyServiceRequestFormGroup.controls['addNewPolicyRequestTextAreaField'].value
            }
        })
        const isPolicySelectRequestValid = this.validateAddNewPolicySelectRequest({
            target: {
                value: this.addNewPolicyServiceRequestFormGroup.controls['addNewPolicySelectRequest'].value
            }
        })
        const isAddNewPolicyDatePickerValid = this.validateAddNewPolicyDatePicker({
            target: {
                value: this.addNewPolicyServiceRequestFormGroup.controls['addNewPolicyDatePicker'].value
            }
        })

        console.log('test', this.addNewPolicyServiceRequestFormGroup);
        console.log('a', this.requestDetailsData);
    }
    proceedWithCancel() {
        this.addNewPolicyServiceRequestFormGroup?.reset();
        this.showCancelConfirmation = false;
        this.router.navigate([`/program/service-requests`]);
        this.addNewPolicyServiceRequestFormGroup = this.fb.group({
            insuredNameInput: [''],
            companyNameInput: [''],
            addressLine1Input: [''],
            addressLine2Input: [''],
            cityNameInput: [''],
            zipcodeInput: [''],
            phoneNumberInput: [''],
            extensionInput: [''],
            recipientMailInput: [''],
            addNewPolicyState: [''],
            addNewPolicySelectRequest: [''],
            addNewPolicyDatePicker: [''],
            dateNeededDatePicker: [''],
            addNewPolicyRequestTextAreaField: ['']
        });
    }
    validateAddNewPolicySelectRequest(event) {
        for (let i = 0; i < this.requestDetailsData.length; i++) {
            if (!(this.requestDetailsData[i]['requestDetailsTypeFormControl']['value'])) {
                this.requestDetailsData[i]['requestDetailsTypeFormControl'].validations = this.requestDataValidationMessage;
            }
            else {
                this.requestDetailsData[i]['requestDetailsTypeFormControl'].validations = []
            }
        }
    }
    validateAddNewPolicyDatePicker(event) {
        for (let i = 0; i < this.requestDetailsData.length; i++) {
            if (!(this.selectedDateList[i])) {
                this.requestDetailsData[i]['requestDetailsDateControl'].validations = this.requestDateValidation;
            }
            else {
                this.requestDetailsData[i]['requestDetailsDateControl'].validations = []
            }
        }
    }
    validateAddNewPolicyRequestTextAreaFieldConfig(event) {
        for (let i = 0; i < this.requestDetailsData.length; i++) {
            if (!(this.requestDetailsData[i]['requestDetailsTextAreaControl']['value'])) {
                this.requestDetailsData[i]['requestDetailsTextAreaControl'].validations = this.requestTextAreaValidation;
            }
            else {
                this.requestDetailsData[i]['requestDetailsTextAreaControl'].validations = []
            }
        }
    }



}
